import { useGetFamilyMemberLeaderboardQuery, useGetLeaderboardDataQuery } from '~/Leaderboard/apis/leaderboard-api'
import { LeagueType } from '~/Leaderboard/types/leaderboard.types'
import { getUserCurrentRank } from '~/Leaderboard/utils/utils'
import { isAuthenticated } from '~/auth/slices/auth.slice'
import useCurrentUser from '~/hooks/useCurrentUser'
import { useAppSelector } from '~/redux/hooks'
import { IUser } from '~/types/user-info-types'

export function useGetLeagueDetails(familyMember?: IUser): {
  leagueIconUrl: string
  currentLeague: number
  userCurrentRank: number
} {
  const authenticated = useAppSelector(isAuthenticated)
  const currentUser = useCurrentUser()
  const user = familyMember ? familyMember : currentUser
  const currentUserLeaderBoard = useGetLeaderboardDataQuery(undefined, { skip: !authenticated })
  const familyMemberLeaderBoard = useGetFamilyMemberLeaderboardQuery(
    { familyMemberId: familyMember?.id },
    { skip: !authenticated || !familyMember?.id },
  )
  const leaderboardData = familyMember ? familyMemberLeaderBoard : currentUserLeaderBoard
  const userId = user?.id || -1
  const currentLeagueUsers = leaderboardData.data?.users || []
  const currentLeague: number =
    leaderboardData.data?.currentLeague && leaderboardData.data?.currentLeague !== 0
      ? leaderboardData.data?.currentLeague
      : 1
  const currentLeagueName: string = LeagueType[currentLeague].toLowerCase()
  const leagueIconUrl: string = `gamification/badges/league/${currentLeagueName}-nav-badge.${
    currentLeague === 5 ? 'svg' : 'png'
  }`
  const userCurrentRank: number = getUserCurrentRank(userId, currentLeagueUsers)

  return { leagueIconUrl, currentLeague, userCurrentRank }
}
